import KunLoading78 from './src/index'

KunLoading78.install = function (Vue) {
	Vue.component(KunLoading78.name, KunLoading78);
}

export default KunLoading78;
